import React from 'react';
import PropTypes from 'prop-types';
import { FONTS } from '../constants/Fonts';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import { TEXT_LABELS } from '../constants/TextLabelConstants';
import './TournamentProgressStepper.css';

const STATUS_LABELS = {
  completed: TEXT_LABELS.TOURNAMENT_STAGE_COMPLETED,
  next: TEXT_LABELS.TOURNAMENT_STAGE_NEXT,
  up_next: TEXT_LABELS.TOURNAMENT_STAGE_UP_NEXT,
  live: TEXT_LABELS.TOURNAMENT_STAGE_LIVE,
};

const DEFAULT_STAGES = [
  {
    id: 'stage-1',
    gameType: 'rap_fire',
    name: TEXT_LABELS.TOURNAMENT_STAGE_RAPFIRE,
    status: 'completed',
    questionNumber: 1,
  },
  {
    id: 'stage-2',
    gameType: 'rap_housie',
    name: TEXT_LABELS.TOURNAMENT_STAGE_RAPHOUSIE,
    status: 'next',
  },
  {
    id: 'stage-3',
    gameType: 'rap_fire',
    name: TEXT_LABELS.TOURNAMENT_STAGE_RAPFIRE,
    status: 'up_next',
    questionNumber: 2,
  },
];

const StageIcon = ({ gameType, icon }) => {
  const isHousie = gameType === 'rap_housie';
  const src =
    icon ||
    (isHousie
      ? IMAGE_CONSTANTS.V2_TOURNAMENT_STEPPER_RAPHOUSIE
      : IMAGE_CONSTANTS.V2_TOURNAMENT_STEPPER_RAPFIRE);

  return (
    <span
      className={`lb-stepper__icon${isHousie && !icon ? ' lb-stepper__icon--housie' : ''}`}
      data-name={isHousie ? 'Housie 1 1' : 'fire_2 1'}
    >
      <img src={src} alt="" width={68} height={68} />
    </span>
  );
};

StageIcon.propTypes = {
  gameType: PropTypes.string,
  icon: PropTypes.string,
};

const StageCard = ({ stage }) => {
  const isDone = stage.status === 'completed' || stage.status === 'live';
  const label = STATUS_LABELS[stage.status] || TEXT_LABELS.TOURNAMENT_STAGE_UP_NEXT;

  return (
    <div
      className={`lb-stepper__card${isDone ? ' lb-stepper__card--done' : ' lb-stepper__card--upcoming'}${
        stage.gameType === 'rap_housie' ? ' lb-stepper__card--housie' : ''
      }`}
      data-status={stage.status}
    >
      <StageIcon gameType={stage.gameType} icon={stage.icon} />
      <div className="lb-stepper__card-copy">
        <p className="lb-stepper__card-name" style={{ fontFamily: FONTS.INTER_SEMIBOLD }}>
          {stage.name}
        </p>
        <p className="lb-stepper__card-status" style={{ fontFamily: FONTS.INTER_REGULAR }}>
          {label}
        </p>
      </div>
    </div>
  );
};

StageCard.propTypes = {
  stage: PropTypes.shape({
    gameType: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    icon: PropTypes.string,
    questionNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
};

/**
 * Figma 20780:14783 — tournament progress header stepper.
 */
const TournamentProgressStepper = ({
  title = TEXT_LABELS.TOURNAMENT_PROGRESS_TITLE,
  subtitle = TEXT_LABELS.TOURNAMENT_PROGRESS_SUBTITLE,
  stages,
}) => {
  const items = stages?.length ? stages : DEFAULT_STAGES;

  return (
    <section
      className="lb-stepper"
      data-node-id="20780:14783"
      aria-label={title}
    >
      <div className="lb-stepper__copy" data-node-id="20780:14780">
        <h2 className="lb-stepper__title" style={{ fontFamily: FONTS.INTER_BOLD }}>
          {title}
        </h2>
        <p className="lb-stepper__subtitle" style={{ fontFamily: FONTS.INTER_SEMIBOLD }}>
          {subtitle}
        </p>
      </div>

      <div className="lb-stepper__stages" data-node-id="20780:14781">
        <span className="lb-stepper__line" aria-hidden="true" />
        {items.map((stage, index) => (
          <StageCard key={stage.id || `stage-${index}`} stage={stage} />
        ))}
      </div>
    </section>
  );
};

TournamentProgressStepper.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  stages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      gameType: PropTypes.string,
      name: PropTypes.string,
      status: PropTypes.string,
      icon: PropTypes.string,
      questionNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
};

TournamentProgressStepper.defaultProps = {
  stages: DEFAULT_STAGES,
};

export default TournamentProgressStepper;
export { DEFAULT_STAGES };
